import * as React from 'react'
import ReactDom from 'react-dom'
import ActivityIndicator from '@componentsG/activityIndicator'

class Loading {
    private div: HTMLElement

    constructor() {
        this.div = document.createElement('div')
    }

    showLoading = (): void => {
        ReactDom.render(<ActivityIndicator toast={true} animating={true}/>, this.div)
        document.body.appendChild(this.div)
    }

    hideLoading = (): void => {
        document.body.removeChild(this.div)
    }
}

const loading = new Loading()
export default loading
